import { SendBrowserAgnosticEvent } from "./browser-agnostic-event";

export default class ToggleActive {
    targets: Array<HTMLElement>;
    trigger: HTMLElement;
    preEvent: Event | undefined;
    postEvent: Event | undefined;
    preEventFunction: ((event: Event) => void) | undefined;
    postEventFunction: ((event: Event) => void) | undefined;

    constructor(targetElements: Array<HTMLElement>, triggerElement: HTMLElement) {
        this.targets = targetElements;
        this.trigger = triggerElement;
        this.trigger.addEventListener("click", (e) => {
            e.preventDefault();
            this.toggle();
        });
    }

    toggle = () => {
        SendBrowserAgnosticEvent(this.trigger, "PreToggle");
        this.targets.forEach((target) => {
            target.classList.toggle("is-active");
        });
        SendBrowserAgnosticEvent(this.trigger, "PostToggle");
    }

    forceOff = () => {
        this.targets.forEach((target) => {
            target.classList.remove("is-active");
        });
    }

    setPreEvent = (eventFunction: (event: Event) => void) => {
        this.preEventFunction = eventFunction;
        this.trigger.addEventListener("PreToggle", this.preEventFunction);
    }

    setPostEvent = (eventFunction: (event: Event) => void) => {
        this.postEventFunction = eventFunction;
        this.trigger.addEventListener("PostToggle", this.postEventFunction);
    }
}